import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowDownWideShort,
  faFire, // for future: Most Popular
} from '@fortawesome/free-solid-svg-icons';

const FilterBar = ({ category, onFilterChange }) => {
  const [priceRange, setPriceRange] = useState('');
  const [sortOption, setSortOption] = useState('');

  const emitChange = (range, sort) => {
    onFilterChange({
      category,
      priceRange: range,
      sortOption: sort,
    });
  };

  const handlePriceChange = (value) => {
    setPriceRange(value);
    emitChange(value, sortOption);
  };

  const handleSortChange = (value) => {
    setSortOption(value);
    emitChange(priceRange, value);
  };

  // const priceRanges = ['0-100', '100-500', '500-1000', '1000+'];
  const priceRanges = [
  // { label: 'All', value: '', min: 0, max: Infinity },
  { label: '≤ 500 SAR', value: '0-500', min: 0, max: 500 },
  { label: '500–1K SAR', value: '500-1000', min: 500, max: 1000 },
  { label: '1K–2K SAR', value: '1000-2000', min: 1000, max: 2000 },
  { label: '2K–3.5K SAR', value: '2000-3500', min: 2000, max: 3500 },
  { label: '3.5K+ SAR', value: '3500+', min: 3500, max: Infinity },
];


  return (
    <div className="w-full bg-base-100 p-4 rounded-2xl shadow-md border border-base-200">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        {/* 💰 Price Range Pills */}
        <div className="flex flex-col gap-2 w-full md:w-auto">
          <span className="text-sm font-semibold text-gray-500">Price Range</span>
          <div className="flex flex-wrap gap-2 overflow-x-auto scrollbar-hide">
            <button
              className={`btn btn-sm rounded-full px-4 ${
                priceRange === '' ? 'btn-primary' : 'btn-outline'
              }`}
              onClick={() => handlePriceChange('')}
            >
              All
            </button>
            {/* {priceRanges.map((range) => (
              <button
                key={range}
                className={`btn btn-sm rounded-full px-4 whitespace-nowrap ${
                  priceRange === range ? 'btn-primary' : 'btn-outline'
                }`}
                onClick={() => handlePriceChange(range)}
              >
                {range} SAR
              </button>
            ))} */}

            {priceRanges.map(({ label, value }) => (
            <button
              key={value}
              className={`btn btn-sm rounded-full px-4 whitespace-nowrap ${
                priceRange === value ? 'btn-primary' : 'btn-outline'
              }`}
              onClick={() => handlePriceChange(value)}
            >
              {label}
            </button>
          ))}

          </div>
        </div>

        {/* 🔽 Sort By Drop Button */}
        <div className="flex gap-2 items-center justify-start md:justify-end flex-wrap">
          <button
            className={`btn btn-sm rounded-full gap-2 ${
              sortOption === 'drop' ? 'btn-secondary' : 'btn-outline'
            }`}
            onClick={() => handleSortChange(sortOption === 'drop' ? '' : 'drop')}
          >
            <FontAwesomeIcon icon={faArrowDownWideShort} className="w-4 h-4" />
            Biggest Drop
          </button>

          {/* 🔥 Most Popular – for later */}
          {/*
          <button
            className={`btn btn-sm rounded-full gap-2 ${
              sortOption === 'popular' ? 'btn-accent' : 'btn-outline'
            }`}
            onClick={() => handleSortChange(sortOption === 'popular' ? '' : 'popular')}
          >
            <FontAwesomeIcon icon={faFire} className="w-4 h-4" />
            Most Popular
          </button>
          */}
        </div>
      </div>
    </div>
  );
};

export default FilterBar;




// import React, { useState } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faArrowDownWideShort, faFire } from '@fortawesome/free-solid-svg-icons';


// const FilterBar = ({ category, onFilterChange }) => {
//   const [priceRange, setPriceRange] = useState('');
//   const [sortOption, setSortOption] = useState('');

//   const emitChange = (range, sort) => {
//     onFilterChange({
//       category,
//       priceRange: range,
//       sortOption: sort,
//     });
//   };

//   const handlePriceChange = (value) => {
//     setPriceRange(value);
//     emitChange(value, sortOption);
//   };

//   const handleSortChange = (value) => {
//     setSortOption(value);
//     emitChange(priceRange, value);
//   };

//   const priceRanges = ['0-100', '100-500', '500-1000', '1000+'];

//   return (
//     <div className="w-full bg-base-100 p-4 rounded-2xl shadow-md flex flex-col md:flex-row justify-between items-center gap-6 border border-base-200">
//       {/* 💰 Price Range Pills */}
//       <div className="flex flex-wrap gap-2 items-center">
//         <span className="text-sm font-semibold text-gray-500">Price:</span>
//         <button
//           className={`btn btn-sm rounded-full px-4 ${
//             priceRange === '' ? 'btn-primary' : 'btn-outline'
//           }`}
//           onClick={() => handlePriceChange('')}
//         >
//           All
//         </button>
//         {priceRanges.map((range) => (
//           <button
//             key={range}
//             className={`btn btn-sm rounded-full px-4 ${
//               priceRange === range ? 'btn-primary' : 'btn-outline'
//             }`}
//             onClick={() => handlePriceChange(range)}
//           >
//             {range} SAR
//           </button>
//         ))}
//       </div>

//       {/* 🔽 Sort By Drop Button */}
//       <div className="flex items-center gap-4">
//       <button
//   className={`btn btn-sm rounded-full gap-2 ${
//     sortOption === 'drop' ? 'btn-secondary' : 'btn-outline'
//   }`}
//   onClick={() =>
//     handleSortChange(sortOption === 'drop' ? '' : 'drop')
//   }
// >
//   <FontAwesomeIcon icon={faArrowDownWideShort} className="w-4 h-4" />
//   Biggest Drop
// </button>


// {/* 🔥 Most Popular */}
// {/*
// <button
//   className={`btn btn-sm rounded-full gap-2 ${
//     sortOption === 'popular' ? 'btn-accent' : 'btn-outline'
//   }`}
//   onClick={() =>
//     handleSortChange(sortOption === 'popular' ? '' : 'popular')
//   }
// >
//   <FontAwesomeIcon icon={faFire} className="w-4 h-4" />
//   Most Popular
// </button>
// */}

//       </div>
//     </div>
//   );
// };

// export default FilterBar;
